module.exports = __webpack_public_path__ + "img/9788994077826.12cca3b7.jpg";